import React, { useState } from "react";
import DisciplinaryTab from "../../../components/disciplinary-tab/DisciplinaryTab";
import { disciplinaryCaseList, tabs } from "../../../misc/constants";
import DisciplinaryStudents from "../../../components/disciplinary-table/DisciplinaryStudents";
import DisciplinaryWarnings from "../../../components/disciplinary-table/DisciplinaryWarnings";
import DisciplinaryCases from "../../../components/disciplinary-table/DisciplinaryCases";
import { DisciplinaryCaseType } from "../../../misc/types";
import DisciplinarySpecies from "../../../components/disciplinary-table/DisciplinarySpecies";
import { DisciplinaryCasesPage } from "../../../components/disciplinary-table/DisciplinaryCasesPage";
import { DisciplinaryHearings } from "../../../components/disciplinary-table/DisciplinaryHearings";

const Disciplinary = () => {
  const [activeTab, setActiveTab] = useState(tabs[0].id);

  const handleTabChange = (tabId: string) => {
    setActiveTab(tabId);
  };

  return (
    <div className='bg-[#f8f9fd] h-full text-black p-5 text-sm overflow-y-auto flex flex-col'>
      <DisciplinaryTab onTabChange={handleTabChange} activeTab={activeTab} />
      {activeTab === "students" ? (
        <DisciplinaryStudents />
      ) : (
        <div className='bg-white p-4 rounded-lg flex flex-col gap-5 min-h-[90%] overflow-y-auto'>
          {["cases", "decide_cases", "hearings_cases"].includes(activeTab) && (
            <DisciplinaryCasesPage type={activeTab} />
          )}
          {activeTab === "warnings" && (
            <DisciplinaryWarnings caseItem={disciplinaryCaseList[0]} />
          )}
          {activeTab === "species" && <DisciplinarySpecies />}
          {activeTab === "hearings" && <DisciplinaryHearings />}
        </div>
      )}
    </div>
  );
};

export default Disciplinary;
